
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IGridLayoutSelector, IMetadataAction } from "@tylertech/tyler-api-types";

/**
 * GridLayoutService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class GridLayoutService {
    private readonly $apiService = inject(ApiService);
    
    LoadLayoutAction(selector: IGridLayoutSelector): Promise<IMetadataAction> {
        return this.$apiService.sendAuth("IGridLayoutService/LoadLayoutAction", selector);
    }
}
